import { useFeatureFlags } from 'common/hooks';
import useUser from 'common/hooks/useUser';

const FEATURE_FLAG_NAME = 'enable_support_layer_merchant_admin';

export const useIsSupportLayerEnabled = () => {
  const { user } = useUser();

  const { data, isLoading } = useFeatureFlags([FEATURE_FLAG_NAME], {
    user_id: user?.id ?? '',
    user_country: user?.country ?? '',
  });

  return !isLoading && data?.[FEATURE_FLAG_NAME] === 'on';
};
